import React from 'react';
import { TouchableOpacity, StyleSheet, View } from 'react-native';
import { Color, CommonProperties } from '../styles';
import Icon from './Icon';
import BaseText from './BaseText';
import { scale } from '../utils/scale.utils';

const ExpenseCheckbox = ({ label, checked, onPress }) => {
  return (
    <TouchableOpacity style={styles.container} onPress={onPress}>
      <View style={[styles.checkbox, checked ? styles.checked : styles.unchecked]}>
        {checked && <Icon name="check" size={16} color="white" />}
      </View>
      <BaseText style={styles.label}>{label}</BaseText>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  checkbox: {
    width: scale(25),
    height: scale(25),
    borderWidth: scale(1),
    marginRight: scale(4),
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: scale(7),
  },
  checked: {
    backgroundColor: Color.active,
    borderColor: Color.active,
  },
  unchecked: {
    borderColor: Color.grayText,
  },
  label: {
    ...CommonProperties.custom,
  },
});

export default ExpenseCheckbox;
